import React, {useState} from 'react';
import 'contents/assets/scss/page/data.scss';
import Paging from '../../component/Inc/Paging';
import Upload from '../../component/Inc/Upload';
import Tab from '../../component/Inc/Tab';
import BtnLike from "../../component/Inc/BtnLike";//좋아요 버튼
function DataVideo() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '국어', value: 0},
    {title: '영어', value: 1},
    {title: '수학', value: 2},
    {title: '사탐', value: 3},
    {title: '과탐', value: 4},
    {title: '수시', value: 5}
  ];
  return (
    <main className="com_container p_expecting_exam">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu4_5">내신 출제 예상 자료</h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_plus">출간 교재 공지 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="단어 검색" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <table className="com_board_list">
              <colgroup>
                <col width="70" />
                <col width="110" />
                <col width="110" />
                <col width="auto" />
                <col width="100" />
                <col width="110" />
                <col width="110" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>과목</th>
                  <th>내용</th>
                  <th>파일</th>
                  <th>등록자</th>
                  <th>다운로드 횟 수</th>
                </tr>
              </thead>
              <tbody>
                <tr className="selected">
                  <td>
                  <BtnLike/>
                  </td>
                  <td className="td_date">2022.08.25</td>
                  <td>국어</td>
                  <td>[출간] 고난도 이지솔루션(2101)학년도 4종</td>
                  <td>
                    <button className="btn_link blue">
                      교재
                      <br />
                      정답표
                    </button>
                  </td>
                  <td>김길동 103</td>
                  <td>123</td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{10 - idx}</td>
                      <td className="td_date">2022.08.25</td>
                      <td>국어</td>
                      <td>[출간] 고난도 이지솔루션(2101)학년도 4종</td>
                      <td>
                        <button className="btn_link blue">
                          교재
                          <br />
                          정답표
                        </button>
                      </td>
                      <td>김길동 103</td>
                      <td>123</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <div className="count">
                <p>
                  댓글 <span className="cnt">10</span>
                </p>
                <span className="dot" />
                <p>
                  조회 <span className="cnt">321</span>
                </p>
              </div>
            </div>
            <div className="com_input_wrap">
              <div className="sec_input select_box">
                <select className="select">
                  <option value="">과목 선택</option>
                </select>
                <div className="com_btn_wrap">
                  <BtnLike/>
                  <button className="btn_edit"></button>
                  <button className="btn_delete"></button>
                </div>
              </div>
              <div className="sec_input">
                <input type="text" className="input" placeholder="제목 입력" />
              </div>
              <div className="editor">내용입력(에디터)</div>
              <div className="com_input_upload">
                <Upload title="파일 등록" className="com_btn gray s wl" />
                <p className="file">
                  <span className="txt">File name.pdf</span>
                  <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  <button type="button" className="btn_down" onClick={() => {}}></button>
                </p>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_btn_wrap center bottom">
              <div className="com_btn orange xs wl">등록</div>
            </div>
            <div className="com_board_box">
              <div className="detail_tit_sub">
                <p className="name">다운로드 정보</p>
              </div>
              <div className="board_item download_wrap">
                <div className="down_list">
                  {[...Array(30)].map((i, idx) => {
                    return (
                      <div className="info" key={idx}>
                        <span className="cont">
                          <button className="btn_link">김담임102 </button>
                          <span className="desc dot">2025, 05, 20 11 : 30</span>
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}

export default DataVideo;
